module.exports = __webpack_public_path__ + "img/img-1.fc90b25a.jpg";